'use client';

import { create } from 'zustand';

/**
 * A refused wizard render, handed to the concept page it navigates to. In
 * memory only: handled once, on arrival, by the same handler the Generate
 * button uses.
 */
export interface FirstRunHandoff {
  conceptId: string;
  error: unknown;
}

interface FirstRunSessionState {
  /**
   * The wizard was presented in this app session. It is shown at most once
   * per session: leaving it (close, back, Later) must never bring it back
   * until the next session, and it never blocks other navigation.
   */
  presentedThisSession: boolean;
  handoff: FirstRunHandoff | null;
  markPresented: () => void;
  setHandoff: (handoff: FirstRunHandoff) => void;
  clearHandoff: () => void;
}

export const useFirstRunSession = create<FirstRunSessionState>((set) => ({
  presentedThisSession: false,
  handoff: null,
  markPresented: () => set({ presentedThisSession: true }),
  setHandoff: (handoff) => set({ handoff }),
  clearHandoff: () => set({ handoff: null }),
}));
